import {
  uploadFile as uploadFileApi,
  uploadFileV2 as uploadFileApiV2,
  deleteFile as deleteFileApi,
} from "api";
import {
  CollectionReference,
  DocumentData,
  DocumentReference,
  deleteDoc,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";
import i18next from "i18next";

type FileDocument = {
  collectionRef: CollectionReference;
  data: DocumentData;
};

export const uploadFile = async (
  file: File,
  { collectionRef, data }: FileDocument,
  filename?: string
) => {
  const docRef = filename ? doc(collectionRef, filename) : doc(collectionRef);

  await setDoc(docRef, {
    ...data,
    name: file.name || "",
    uploaded: false,
    archived: false,
    url: null,
    contentType: file.type,
    size: 0,
    updatedAt: Date.now(),
    createdAt: Date.now(),
  });

  const uploadResult = await uploadFileApi({
    file,
    filePath: docRef.path,
  }).catch(() => {
    window.alert(
      i18next.t(
        "ファイルアップロードに失敗しました。ファイル容量が大きすぎる可能性があります。"
      )
    );
  });

  if (uploadResult) {
    const url = [process.env.REACT_APP_CDN_URL, uploadResult.name].join("/");
    try {
      await setDoc(
        docRef,
        {
          uploaded: true,
          url,
          contentType: uploadResult.contentType,
          size: uploadResult.size,
          updatedAt: Date.now(),
        },
        { merge: true }
      );
      return { doc: docRef, file, url };
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  // 直 upload
  // const storageRef = storage.ref(docRef.path);
  // const uploaded = await storageRef.put(file).catch(() => {
  //   alert(
  //     `ファイルアップロードに失敗しました。ファイル容量が大きすぎる可能性があります。`
  //   );
  // });

  // if (!uploaded) {
  //   docRef.delete();
  //   return;
  // }
  // const metadata = await storageRef.updateMetadata({
  //   cacheControl: `public,max-age=${maxAge}`, // 30days
  // });
  // const downloadURL = await storageRef.getDownloadURL();
  // await docRef.set(
  //   {
  //     uploaded: true,
  //     url: downloadURL,
  //     contentType: metadata.contentType,
  //     size: metadata.size,
  //     updatedAt: Date.now(),
  //   },
  //   { merge: true }
  // );
  // return { doc: docRef, file, url: downloadURL };
};

export const uploadFileV2 = async (
  file: File,
  { collectionRef, data }: FileDocument,
  filename?: string
) => {
  const docRef = filename ? doc(collectionRef, filename) : doc(collectionRef);
  const docSnapshot = await getDoc(docRef);

  if (docSnapshot.exists()) {
    await setDoc(
      docRef,
      {
        archived: false,
        updatedAt: Date.now(),
        ...data,
      },
      { merge: true }
    );
  } else {
    await setDoc(docRef, {
      ...data,
      name: file.name || "",
      uploaded: false,
      archived: false,
      url: null,
      contentType: file.type,
      size: 0,
      updatedAt: Date.now(),
      createdAt: Date.now(),
    });
  }

  const uploadResult = await uploadFileApiV2({
    file,
    filePath: docRef.path,
  }).catch(() => {
    window.alert(
      i18next.t(
        "ファイルアップロードに失敗しました。ファイル容量が大きすぎる可能性があります。"
      )
    );
  });

  if (uploadResult) {
    // URLにキャッシュバスティング用のクエリ文字列を付与
    const timestamp = Date.now();
    const baseUrl = [process.env.REACT_APP_CDN_URL, uploadResult.name].join(
      "/"
    );
    const url = `${baseUrl}?t=${timestamp}`;

    try {
      // アップロードの処理タイミングで並び順が変わることを防ぐため updatedAt は更新しない
      await setDoc(
        docRef,
        {
          archived: false,
          uploaded: true,
          url,
          contentType: uploadResult.contentType,
          size: uploadResult.size,
        },
        { merge: true }
      );
      return { doc: docRef, file, url };
    } catch (err) {
      console.error(err);
      return null;
    }
  }
};

export const deleteFile = async (docRef: DocumentReference<unknown>) => {
  try {
    await deleteFileApi(docRef.path);
  } catch (err) {
    console.error(err);
  }
  return deleteDoc(docRef);
};
